<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <h4>Edição de Dados</h4>
            <form @submit.prevent="onSubmit">
                <div class="row row-space">
                    <div class="form-item" style="flex: 0 0 160px;">
                        <label class="label-caption" for="fone">Telefone</label>
                        <input type="text" v-model="edFone" id="fone" v-phone maxlength="15" required />
                    </div>
                </div>

                <div class="row-start">
                    <button type="submit" class="btn-confirm">Confirmar</button>
                    <button type="button" class="btn-cancel" @click="closeModal">Cancelar</button>
                </div>
            </form>
        </div>
    </div>
</template>
  
<script>
import { ref, computed } from 'vue';

export default {
    props: {visible: {type: Boolean, required: true,},},
    emits: ['update:visible', 'submit'],
        
    setup(props, { emit }) {
        const edFone = ref(null);

        const isVisible = computed(() => props.visible);

        const onSubmit = () => {
            emit('submit', { fone: edFone.value });
            closeModal();
        };

        const closeModal = () => {
            emit('update:visible', false);
        };

        return { isVisible, edFone, onSubmit, closeModal, };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}
</style>
  